define('SuiteCommerce.ItemBadges.View', [
  'Backbone',
  'Backbone.CollectionView',
  'SuiteCommerce.ItemBadges.BadgesList.View',
  'SuiteCommerce.ItemBadges.Configuration',
  'underscore',
  'itembadges_view.tpl',
  'SuiteCommerce.ItemBadges.Instrumentation.InstrumentationHelper'
], function ItemBadgesView(
  Backbone,
  BackboneCollectionView,
  ItemBadgesbadgesListView,
  Configuration,
  _,
  itembadgesViewTpl,
  InstrumentationHelper
) {
  'use strict';

  return Backbone.View.extend({
    template: itembadgesViewTpl,

    contextDataRequest: ['item'],

    initialize: function initialize(options) {
      var self = this;

      this.items = options.items;
      this.collection = options.collection;
      this.currentView = options.view;
      this.position = Configuration.get('itemBadges').position.toLowerCase().replace(/\s/, '-');

      _.defer(function deferedRender() {
        self.registerInstrumentationLog();
        self.render();
      });
    },

    registerInstrumentationLog: function registerInstrumentationLog() {
      var instrumentationLog;
      var activity;
      if (this.badgeCollection.length) {
        switch (this.currentView) {
          case 'pdp':
            activity = 'Item badges loaded on PDP';
            break;
          case 'plp':
            activity = 'Item badges loaded on PLP';
            break;
          default:
        }
        instrumentationLog = InstrumentationHelper.getLog('instrumentationLog');
        instrumentationLog.setParametersToSubmit({
          componentArea: 'SC Item Badges',
          activity: activity,
          quantity: this.badgeCollection.length
        });
        instrumentationLog.submit();
      }
    },

    getContext: function getContext() {
      var itemBadges;
      var item;
      var showBadges;

      switch (this.currentView) {
        case 'pdp':
          showBadges = this.items.item.custitem_ns_ib_show_badges;
          itemBadges = this.items.item.custitem_ns_ib_badges;
          break;
        default:
          item = this.contextData.item();
          showBadges = item.custitem_ns_ib_show_badges;
          itemBadges = item.custitem_ns_ib_badges;
      }

      if (itemBadges && itemBadges.split(',').length >= 3) {
        itemBadges = itemBadges.split(',').slice(0, 3) + '';
      }

      this.badgeCollection = this.collection.filterBadges(itemBadges || false);

      return {
        hasBadges: showBadges && !!this.badgeCollection,
        position: this.position
      };
    },

    childViews: {
      'Itembadges.List.View': function ItembadgesListView() {
        return new BackboneCollectionView({
          collection: this.badgeCollection,
          childView: ItemBadgesbadgesListView,
          childViewOptions: {
            currentView: this.currentView,
            position: this.position
          }
        });
      }
    }
  });
});
